import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogTrigger,
} from "./ui/dialog";
import { useLang } from "../lib/i18n";

const CONTENT_CLASS =
  "bg-[#150b12] border border-cream/10 text-cream max-w-2xl rounded-2xl max-h-[80vh] overflow-y-auto backdrop-blur-xl";

const URL_RE = /(https?:\/\/[^\s]+)/g;

const LinkedText = ({ text, newWindowLabel }) => {
  const parts = String(text).split(URL_RE);
  return parts.map((part, i) =>
    part.startsWith("http") ? (
      <a
        key={i}
        href={part}
        target="_blank"
        rel="noopener noreferrer"
        className="underline text-cream/80 break-all"
      >
        {part}
        {newWindowLabel ? <span className="sr-only"> {newWindowLabel}</span> : null}
      </a>
    ) : (
      part
    )
  );
};

const SectionBody = ({ p, ul, newWindowLabel }) => {
  const paras = p == null ? [] : Array.isArray(p) ? p : [p];
  return (
    <>
      {paras.map((text, j) => (
        <p key={j} className={j > 0 ? "mt-2" : ""}>
          <LinkedText text={text} newWindowLabel={newWindowLabel} />
        </p>
      ))}
      {ul?.length ? (
        <ul className="mt-2 list-disc pl-5 space-y-1">
          {ul.map((item) => (
            <li key={item}>
              <LinkedText text={item} newWindowLabel={newWindowLabel} />
            </li>
          ))}
        </ul>
      ) : null}
    </>
  );
};

const SectionsDialog = ({ data, trigger, triggerClassName, testid }) => {
  const { t } = useLang();
  return (
  <Dialog>
    <DialogTrigger asChild>
      <button type="button" data-testid={testid} className={triggerClassName}>
        {trigger ?? data.trigger}
      </button>
    </DialogTrigger>
    <DialogContent className={CONTENT_CLASS} closeLabel={t.common.close}>
      <DialogHeader>
        <DialogTitle className="font-display uppercase tracking-tight text-gradient">{data.title}</DialogTitle>
        <DialogDescription className="sr-only">{data.title}</DialogDescription>
        {data.updated ? (
          <p className="text-xs text-[#a08f9c] font-light pt-1">{data.updated}</p>
        ) : null}
      </DialogHeader>
      <div className="text-sm text-[#a08f9c] font-light space-y-5 leading-relaxed">
        {data.sections.map((s, i) => (
          <div key={i}>
            <h3 className="text-cream font-normal mb-1 text-sm">{s.h}</h3>
            <SectionBody p={s.p} ul={s.ul} newWindowLabel={t.common.newWindow} />
          </div>
        ))}
      </div>
    </DialogContent>
  </Dialog>
  );
};

export const LegalDialog = ({ triggerClassName = "", testid = "legal-trigger" }) => {
  const { t } = useLang();
  return <SectionsDialog data={t.legal} triggerClassName={triggerClassName} testid={testid} />;
};

export const PrivacyDialog = ({ trigger, triggerClassName = "", testid = "privacy-trigger" }) => {
  const { t } = useLang();
  return <SectionsDialog data={t.privacy} trigger={trigger} triggerClassName={triggerClassName} testid={testid} />;
};

export const CguDialog = ({ trigger, triggerClassName = "", testid = "cgu-trigger" }) => {
  const { t } = useLang();
  return <SectionsDialog data={t.cgu} trigger={trigger} triggerClassName={triggerClassName} testid={testid} />;
};
